import { useFlags, useFlagsLoaded } from "@/hooks/useFeatureFlags";

export function useNatlCommitteeManagementGate() {
  const flags = useFlags();
  const flagsLoaded = useFlagsLoaded();

  return {
    flagsLoaded,
    enabled: flags["backoffice-natl-committee-management"] === true
  };
}

export function useNatlCommitteeManagementEnabled() {
  return useNatlCommitteeManagementGate().enabled;
}
